// extracted by mini-css-extract-plugin
export default {"btn":"SpinButton_btn__6i1Bs"};